export const BrandColors = {
    GREEN: '#51eb2b',
    BLACK: '#000',
    WHITE: '#FFF'
};